const enum ErrorCode {
  Unknown = 0,
}

export default ErrorCode;
